import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'lib-file-preview-grid',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  template: `
    <div class="file-preview-grid-wrapper">
        <!-- Control Bar -->
        <div class="grid-controls" *ngIf="showControls && hasItems">
            <div class="controls-actions">
                <button mat-flat-button color="warn" (click)="clearAll.emit()" class="rounded-lg !h-9">
                    <mat-icon class="mr-1">delete_sweep</mat-icon>
                    Clear All
                </button>
                <button *ngIf="showResetOrder" mat-stroked-button (click)="resetOrder.emit()" class="rounded-lg !h-9">
                    <mat-icon class="mr-1">restore_page</mat-icon>
                    Reset Order
                </button>
            </div>
            <div class="items-count-badge">
                <span class="items-count">{{ itemCount }} Files Selected</span>
            </div>
        </div>

        <!-- Grid Container Projection -->
        <ng-content></ng-content>
    </div>
  `,
  styleUrl: './file-preview.css'
})
export class FilePreviewGrid {
  @Input() showControls = true;
  @Input() showResetOrder = true;
  @Input() hasItems = false;
  @Input() itemCount = 0;

  @Output() clearAll = new EventEmitter<void>();
  @Output() resetOrder = new EventEmitter<void>();
}
